/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsQRCode
 */
export interface MelcoModelsQRCode {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsQRCode
     */
    url?: string | null;
}

export function MelcoModelsQRCodeFromJSON(json: any): MelcoModelsQRCode {
    return MelcoModelsQRCodeFromJSONTyped(json, false);
}

export function MelcoModelsQRCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsQRCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function MelcoModelsQRCodeToJSON(value?: MelcoModelsQRCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}


